const Data = [
    {
        name: "Pradumn Krishna",
        position: "Public Relations and Marketing Head",
        imageUrl: "/assets/images/members/Heads21/Pradumn Krishna.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
        email: "gywsociety@gmail.com"
    },
    {
        name: "Rishabh Goyal",
        position: "Public Relations and Marketing Head",
        imageUrl: "/assets/images/members/Heads21/Rishabh Goyal.jpeg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
        email: "gywsociety@gmail.com"
    },
    {
        name: "Nimisha Singh",
        position: "Public Relations and Marketing Head",
        imageUrl: "/images/profile.png",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
        email: "gywsociety@gmail.com"
    },
    {
        name: "Aakanksha Gupta",
        position: "Human Resource and Management Head",
        imageUrl: "/assets/images/members/Heads21/Aakanksha Gupta.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
        email: "gywsociety@gmail.com"
    },
    {
        name: "Akash Agarwal",
        position: "Human Resource and Management Head",
        imageUrl: "/assets/images/members/Heads21/Akash Agarwal.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
        email: "gywsociety@gmail.com"
    },
    {
        name: "Aniruddh Solanki",
        position: "Human Resource and Management Head",
        imageUrl: "/assets/images/members/Heads21/Aniruddh Solanki.jpeg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
        email: "gywsociety@gmail.com"
    },
   
   
]

export default Data;